var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#008CFF",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.997,
    cy: 12.259,
    fill: "#FFF",
    rx: 8.12,
    ry: 8.259
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.53 9.7l-4.844 4.927M9.685 9.7l4.844 4.927"
  }))));
}
export default SvgCancel;